<template>
    <v-dialog
        v-model="$props.params.addEditSubUsersDialog"
        transition="dialog-bottom-transition"
        max-width="600px"
        @keydown.esc="closeAddEditSubUsersDialog()"
        @click:outside="closeAddEditSubUsersDialog()"
    >
        <v-form @submit.prevent="processAddEditSubUsers()">
            <v-card>
                <v-toolbar
                    color="primary"
                    dark
                    :class="dialogHeadingClasses()"
                >
                    <v-icon v-text="icons.mdiPlusCircleOutline" class="mr-3" v-if="$props.params.mode === 'add'"></v-icon>
                    <v-icon v-text="icons.mdiPencilCircleOutline" class="mr-3" v-else></v-icon>
                    <div v-text="$gettextInterpolate($gettext('Add a sub user for %{user}'), {user: $props.params.userParent})" v-if="$props.params.mode === 'add'"></div>
                    <div v-text="$gettextInterpolate($gettext('Edit a sub user for %{user}'), {user: $props.params.userParent})" v-else-if="$props.params.mode === 'edit'"></div>
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" @click.native.stop="closeAddEditSubUsersDialog()" v-text="icons.mdiClose"></v-icon>
                    <v-icon @click.native.stop="processAddEditSubUsers()" v-text="icons.mdiContentSave"></v-icon>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="mt-8">
                    <v-container>
                        <v-row>
                            <v-col cols="12">

                                <v-text-field
                                    :label="$gettext('Sub user name')"
                                    required
                                    :placeholder="$gettext('Sub user name')"
                                    v-model="subUserNameField"
                                    :error-messages="subUserNameErrors"
                                    outlined
                                    @input="$v.subUserNameField.$touch()"
                                    @blur="$v.subUserNameField.$touch()"
                                ></v-text-field>

                                <v-text-field
                                    :label="$gettext('Sub user password')"
                                    required
                                    :placeholder="$gettext('Sub user password')"
                                    :hint="$props.params.mode === 'edit Disabled for now' ? 'Provide only if you wish to change the password': ''"
                                    :persistent-hint="$props.params.mode === 'edit'"
                                    v-model="subUserPassword"
                                    :error-messages="subUserPasswordErrors"
                                    outlined
                                    @input="$v.subUserPassword.$touch()"
                                    @blur="$v.subUserPassword.$touch()"
                                    :type="passwordFieldType"
                                    :append-icon="(passwordFieldType === 'password') ? 'mdi-eye' : 'mdi-lock-outline'"
                                    @click:append="togglePasswordFieldType()"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions color="secondary">
                    <v-spacer></v-spacer>
                    <v-btn class="primary" @click.native.stop="closeAddEditSubUsersDialog()" v-text="$gettext('Close')"></v-btn>
                    <v-btn class="primary" type="submit" v-text="$gettext('Save')"></v-btn>
                </v-card-actions>
            </v-card>
        </v-form>

        <snackbar ref="snackbar"></snackbar>
    </v-dialog>
</template>
<style type="text/scss">
.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}

</style>

<script>

import Vue from 'vue'
import { find, findIndex } from 'lodash'

import Vuelidate from 'vuelidate'
import { required, minLength, maxLength, between } from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinConfigUsers from '@/mixins/database/MixinConfigUsers'
import MixinVuelidate from '@/mixins/MixinVuelidate'

Vue.use(Vuelidate)

export default {
    components: { Snackbar },
    mixins: [MixinDialog, MixinIcon, MixinStringManipulation, MixinConfigUsers, MixinVuelidate],
    props: {
        params: {
            required: true,
            type: Object,
        },
    },
    watch: {
        // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
        addEditSubUsersDialog (newVal) {
            let self = this

            if (newVal) {
                self.subUserNameField = self.$props.params.subUserNameField
            } else {
                self.resetForm()
            }

        }
    },
    mounted () {
        let self = this
        // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
        self.subUserNameField = self.$props.params.subUserName
        self.subUserPassword = self.$props.params.password

    },
    data () {
        return {
            subUserNameField: '',
            // Do not rename this to password, it's conflicting with the password field from the login page.
            subUserPassword: '',
            passwordFieldType: 'password',
        }
    },

    methods: {

        togglePasswordFieldType () {
            this.passwordFieldType = (this.passwordFieldType === 'password') ? 'text' : 'password'
        },

        async processAddEditSubUsers () {

            let self = this
            self.$v.$touch()
            // this seems to get the validation process a start, and we then wait as the isUnique check is a promise .
            await self.$v.$invalid
            await self.$nextTick()
            await self.$nextTick() // safety net

            // Just another safety net
            setTimeout(() => {

                if ( ! self.$v.$invalid) {

                    let node = {
                        key: self.subUserNameField,
                        value: {
                            'password': self.subUserPassword
                        }
                    }

                    if (self.$props.params.mode === 'edit') {
                        self.configUserProcessUpdateUserChildNode(self.$props.params.userCategoryParent, self.$props.params.userParent, self.$props.params.subUserName, node, 'subusers', self.$gettext('Sub user'))
                    } else if (self.$props.params.mode === 'add') {
                        self.configUserAddUserChildNode(self.$props.params.userCategoryParent, self.$props.params.userParent, node, 'subusers')
                    }

                    self.closeAddEditSubUsersDialog()

                }

            }, 100)

        },

        closeAddEditSubUsersDialog () {
            let self = this
            self.$parent.closeDialog('addEditSubUsersDialog')
        },
        resetForm () {
            let self = this
            self.$v.$reset()
            self.subUserNameField = ''
        },
    },
    computed: {

        tPath () {
            return 'pages.home.tabs.users.dialogs.addEditSubUsers.'
        },

        subUserNameErrors () {
            const errors = []
            if ( ! this.$v.subUserNameField.$dirty) return errors
            ! this.$v.subUserNameField.required && errors.push(this.$gettext('Sub user name is required'))
            return errors
        },

        subUserPasswordErrors () {
            const errors = []
            if ( ! this.$v.subUserPassword.$dirty) return errors
            ! this.$v.subUserPassword.required && errors.push(this.$gettext('Sub user password is required'))
            ! this.$v.subUserPassword.isUnique && errors.push(this.$gettext('Sorry! It appears we already have this password in use.'))
            return errors
        }

    },
    validations: {
        subUserPassword: {
            required,
            async isUnique (value, vm) {
                return await this.vuelidateIsUniqueForTwoLevelNestedCustomColumn(value, this.users, 'subusers', 'password', vm.$props.params.password)
            }
        },
        subUserNameField: {
            required,
        }
    }

}
</script>
